import { Box } from "@mui/material"
import { BreadCrumb, SnackSimple } from "../../../../components"
import { CustomePanel, CustomeTab } from "../../../../components/customeTab"
import { TabsItemFilesDeatil } from "../../utils/enums/tabs"
import { useTranslation } from "react-i18next"
import { ListTabItem } from "../../../../components/customeTab/types"
import { useEffect, useMemo, useState } from "react"
import SimpleModal from "../../../../components/modal/simpleModal"
import { FileDetail } from "../detail/components/file"
import { useStyles } from "./styles"
import { Permissions } from "../createFile/components/step2"
import { TabsChildren } from "../../../logbook/pages/main/components/access/utils/enums/tabs"
import { useBody } from "./hooks/body"
import { useFilterTabel } from "./hooks/useFilterTable"
import { useInput } from "./hooks/useInput"
import { useGetData } from "./hooks/getData"
import { useTables } from "./hooks/useTable"
import { EditViewNavigate } from "../../utils/enums/menu"
import { useNavigate } from "react-router-dom"
import Loader from "../../../../components/loader"


export const FileManagerEdit = () => {

    const styles = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()


    const tabs: ListTabItem[] = [
        {
            id: TabsItemFilesDeatil.FILE,
            label: t('filesManager.tabs.file'),
            value: TabsItemFilesDeatil.FILE
        },
        {
            id: TabsItemFilesDeatil.PERMISSIONS,
            label: t('filesManager.tabs.permissions'),
            value: TabsItemFilesDeatil.PERMISSIONS
        },
    ]

    const [tabValue, setTabValue] = useState(TabsItemFilesDeatil.FILE);
    const [value, setValue] = useState(TabsChildren.USERS)

    const changeTab = ({ value }: { value: TabsItemFilesDeatil }) => {
        setTabValue(value)
    }

    //TabPermissions
    const [userSelected, setUserSelected] = useState<Record<string, boolean>>({})
    const { filterRow } = useFilterTabel()
    const { inputUser, userFilter, input, createFilter, modalLoad, loadings, cancelSearchUsers, searchUsers, loadUsers, closeSnackbar, snackbar, dataUsers, inputFilter, permissionFilter, setDataUsers } = useInput({ setUserSelected, userSelected })
    const { dataEndpoint } = useGetData()
    const {
        setAllUsers,column: columnFolio, row: rowFolio, openModal, userFolioSelected, closeModal, rowFiltered, setAllSettingsFolioUser, deleteSelected, deletedUsersSelecteds, setDeletedSelected,
    } = useTables({ tab: value, dataUsers, setUserSelected, userSelected, dataFilter: permissionFilter.filterData, filterRow })

    const body = useBody({userFolioSelected, userFilter});

    const unselectOrSelectAllUserManage = ({ value }: { value: boolean }) => {
        let body: Record<
            string,
            {
                seeFile?: boolean
                downloadFile?: boolean
            }
        > = structuredClone(userFolioSelected)

        const filter = filterRow({ list: rowFolio, value: permissionFilter.filterData })

        filter?.forEach((item) => {
            body = {
                ...body,
                [item.id?.toString() ?? '']: {
                    ...userFolioSelected[item.id?.toString() ?? ''],
                    seeFile: value,
                    downloadFile: value
                },
            }
        })

        return { body, filter }
    }

    const unSelectOrSelectAllUsersFolios = ({ value }: { value: boolean }) => {
        const { body, filter } = unselectOrSelectAllUserManage({ value })
        setAllSettingsFolioUser({ userFolio: body, skip: !value, filter })
    }

    const listBreadCrumb = useMemo(() => {
        if (body.option == EditViewNavigate.DETAIL) {
            return [
                {
                    id: 'filesManager',
                    label: 'filesManager',
                    navigate: () => { navigate(`/dashboard/filesManager/main`) }
                },
                {
                    id: 'detail',
                    label: 'filesManagerDetail',
                    navigate: () => { navigate(`/dashboard/filesManager/detail/${body.fileId}`) }
                },
                {
                    id: 'edit',
                    label: 'filesManagerEdit',
                    navigate: () => { }
                },
            ]
        } else {
            return [
                {
                    id: 'filesManager',
                    label: 'filesManager',
                    navigate: () => { navigate(`/dashboard/filesManager/main`) }
                },
                {
                    id: 'edit',
                    label: 'filesManagerEdit',
                    navigate: () => { }
                },
            ]
        }
    }, [])

    const getInitialValues = () => {

        let body: Record<string, boolean> = {}
        let bodyFolio: Record<
            string,
            {
                seeFile: boolean,
                downloadFile: boolean,
            }
        > = {}

        dataEndpoint?.forEach((itemUsers) => {

            bodyFolio = {
                ...bodyFolio,
                [itemUsers.userId]: {
                    ...bodyFolio[itemUsers.userId],
                    seeFile: !!itemUsers?.seeFile,
                    downloadFile: !!itemUsers?.downloadFile,
                },
            }

            body = {
                ...body,
                [itemUsers.userId]: true,
            }
        })

        setAllSettingsFolioUser({ userFolio: bodyFolio, skip: true })

        if (!!Object.values(body)?.length) {
            setAllUsers({ newSelected: body })
        }

    }

    useEffect(() => {
        getInitialValues()
    }, [dataEndpoint?.length])

    useEffect(() => {
        setDataUsers(prevDataUsers => {
            const updatedUsers = [...prevDataUsers];

            dataEndpoint.forEach(endpoint => {
                const existingUserIndex = updatedUsers.findIndex(user => user.id === endpoint.userId);

                if (existingUserIndex !== -1) {
                    updatedUsers[existingUserIndex] = {
                        areaId: endpoint.areaId,
                        areaName: endpoint.area,
                        departmentId: endpoint.departmentId,
                        departmentName: endpoint.department,
                        id: endpoint.userId,
                        curp: '',
                        division: '',
                        name: endpoint.fullName,
                        userTypeDescription: endpoint.userTypeDescription,
                        roleName: endpoint.role,
                        roleId: endpoint.roleId,
                        userType: endpoint.userType,
                    
                    };
                } else {
                    updatedUsers.push({
                        areaId: endpoint.areaId,
                        areaName: endpoint.area,
                        departmentId: endpoint.departmentId,
                        departmentName: endpoint.department,
                        id: endpoint.userId,
                        curp: '',
                        division: '',
                        name: endpoint.fullName,
                        userTypeDescription: endpoint.userTypeDescription,
                        roleName: endpoint.role,
                        roleId: endpoint.roleId,
                        userType: endpoint.userType,
                    });
                }
            });

            return updatedUsers;
        });
    }, [dataEndpoint])



    return (
        <Box sx={styles.container}>
            <BreadCrumb
                replaceLabels={{ editEdit: 'filesManagerEdit' }}
                breadList={listBreadCrumb}
            />

            <CustomeTab
                listTab={tabs}
                value={tabValue}
                justifyContent="start"
                tabList={{ onChange: (_, value) => { changeTab({ value }) } }}
            >
                <CustomePanel value={TabsItemFilesDeatil.FILE}>
                    {body.loadingDetail ?
                        <Loader />
                        :
                        <FileDetail
                            goBackToList={body.goBackToList}
                            data={body.data}
                            errors={body.errors}
                            file={body.file}
                            setData={body.setData}
                            setErrors={body.setErrors}
                            setFile={body.setFile}
                            status={body.statusFile}
                            solictedUser={body.solictedUser}
                            isEdit
                            deleteUser={body.deleteUser}
                            isLoadingTable={body.isLoadingTable}
                            row={body.row}
                            handleAddUsersSolicited={body.handleAddUsersSolicited}
                            backToDetail={body.option == EditViewNavigate.DETAIL}
                            canDownload={body.canDownload}
                            userCreator={body.userCreator}
                            showOptions={false}
                            handleEditFile={body.handleEditFile}
                            loadingSave={body.loadingSave}
                            canSee={body.canSee}
                            keyFile={body.keyFile}
                            inputUser={inputUser}
                            column={body.column}
                            searchUsersSolicited={body.searchUsersSolicited}
                            userFilter={userFilter}
                            handleShowTable={body.handleShowTable}
                            showTable={body.showTable}
                            canSubmitEdit={body.canSubmitEdit}
                            setCanSubmitEdit={body.setCanSubmitEdit}
                        />
                    }
                </CustomePanel>

                <CustomePanel value={TabsItemFilesDeatil.PERMISSIONS}>
                    <Permissions
                        setValue={setValue}
                        value={value}
                        columnFolio={columnFolio}
                        deleteSelected={deleteSelected}
                        deletedUsersSelecteds={deletedUsersSelecteds}
                        loadingTable={false}
                        permissionFilter={permissionFilter}
                        rowFiltered={rowFiltered}
                        setDeletedSelected={setDeletedSelected}
                        unSelectOrSelectAllUsersFolios={unSelectOrSelectAllUsersFolios}
                        closeModal={closeModal}
                        closeSnackbar={closeSnackbar}
                        inputFilter={inputFilter}
                        openModal={openModal}
                        snackbar={snackbar}
                        cancelSearchUsers={cancelSearchUsers}
                        createFilter={createFilter}
                        input={input}
                        loadUsers={loadUsers}
                        loadings={loadings}
                        modalLoad={modalLoad}
                        searchUsers={searchUsers}
                        haveButtons
                        handleCancel={body.handleCancelPermission}
                        handleSubitmit={body.handleSubmitPermission}
                        submitLoading={body.loadingPermission}
                    />
                </CustomePanel>
            </CustomeTab>


            <SimpleModal
                open={!!body.modal.open}
                next={body.modal.confirm}
                back={body.closeModalIndex}
                close={body.closeModalIndex}
                description={body.modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={body.modal.title}
                loadingButton={false}
            />

            <SnackSimple close={body.handleCloseSnackbar} open={body.openSnackbar.open} type={body.openSnackbar.type} message={body.openSnackbar.message} />
        </Box>
    )
}